import { AxiosResponse } from "axios";
import { call, fork, put, takeLatest } from "redux-saga/effects";

import { IncidentListResponse } from "entities/incidents";
import { IncidentStatistics } from "entities/common";
import { IncidentsApi, StatisticsApi } from "services/http";
import {
  getIncidentListFailure,
  getIncidentListRequest,
  getIncidentListSuccess,
  getIncidentStatisticsFailure,
  getIncidentStatisticsRequest,
  getIncidentStatisticsSuccess,
} from "store/slices/incidentsSlice";

function* getStatisticsFlow(action: { type: string; payload: string | undefined }) {
  try {
    const response: AxiosResponse<IncidentStatistics> = yield call(
      StatisticsApi.getIncidentStatistics,
      action.payload ?? "",
    );
    yield put(getIncidentStatisticsSuccess(response.data));
  } catch {
    yield put(getIncidentStatisticsFailure());
  }
}

function* getListFlow(action: { type: string; payload: string }) {
  try {
    const response: AxiosResponse<IncidentListResponse> = yield call(
      IncidentsApi.getList,
      action.payload,
    );
    yield put(getIncidentListSuccess(response.data));
  } catch {
    yield put(getIncidentListFailure());
  }
}

function* watchGetStatistics() {
  yield takeLatest(getIncidentStatisticsRequest.type, getStatisticsFlow);
}

function* watchGetList() {
  yield takeLatest(getIncidentListRequest.type, getListFlow);
}

export const incidentWatchers = [fork(watchGetStatistics), fork(watchGetList)];
